import { initChatWindowEventHandlers } from '@dc/data-layer/src';

// Page type constants as they appear as the last token in digitalData.page.pageType
const PRODUCT_PAGE = 'product';
const PRODUCT_CONFIRMATION_PAGE = 'add to basket step';
const BASKET_CONFIRMATION_PAGE = 'your order';
const DELIVERY_PAGE = 'delivery options';

// Html elements selectors
const BUTTON_ADD_TO_BASKET = 'form.prd-purchase button.main-purchase-btn';
const BUTTON_REMOVE_AT_CONFIRMATION_PAGE = 'article form.deleteStepPage button';
const INPUT_FUPID_AT_CONFIRMATION_PAGE = 'article form.deleteStepPage input[name=sFUPID]';
const INPUT_SKU_AT_CONFIRMATION_PAGE = 'article form.deleteStepPage input[name=sSKU]';
const INPUT_LABEL_AT_CONFIRMATION_PAGE = 'article form.deleteStepPage input[name=sLabel]';
// const FORM_ADD_TO_BASKET_AT_CONFIRMATION_PAGE =
// '#accessories .shopList .product form.productAdd';
const BUTTON_REMOVE_AT_ORDER_PAGE = 'form.basket-confirmation-form a.iLink[data-product]';
const LINK_REMOVE_AT_DELIVERY_PAGE = '#content a.btn-delete';

/**
 * Attaches click event listeners to the Add to/Remove from basket elements
 *
 * @param      {Store}     store           The store
 */
function initBasketEvents(store) {
  window.digitalData.events = window.digitalData.events || [];

  const pageTypeSane = window.digitalData.page.pageName
    ? window.digitalData.page.pageName.split(':').pop().trim()
    : '';

  // attaching of event listeners per page type
  switch (pageTypeSane) {
    case PRODUCT_PAGE: {
      const btnsProductPage = document.querySelectorAll(BUTTON_ADD_TO_BASKET);
      for (let i = 0; i < btnsProductPage.length; i++) {
        btnsProductPage[i].addEventListener('click', (e) => {
          store.dispatch({
            type: 'EVENTS_CART_PRODUCT_ADD',
            payload: {
              validPageType: PRODUCT_PAGE,
              trackFunctionArgs: 'ProductAddedToBasket'
            }
          });
        });
      }
      break;
    }
    case PRODUCT_CONFIRMATION_PAGE: {
      // product in basket removal
      const removeBtn = document.querySelector(BUTTON_REMOVE_AT_CONFIRMATION_PAGE);
      const productID = document.querySelector(INPUT_FUPID_AT_CONFIRMATION_PAGE).value;
      const productSKU = document.querySelector(INPUT_SKU_AT_CONFIRMATION_PAGE).value;
      const productName = document.querySelector(INPUT_LABEL_AT_CONFIRMATION_PAGE).value;

      if (removeBtn && productID) {
        removeBtn.addEventListener('click', (e) => {
          store.dispatch({
            type: 'EVENTS_CART_PRODUCT_REMOVE',
            payload: {
              productID: productID,
              productSKU: productSKU,
              productName: productName,
              validPageType: PRODUCT_CONFIRMATION_PAGE
            }
          });
        });
      }

      // other offered products Add buttons
      // const addForms = document.querySelectorAll(FORM_ADD_TO_BASKET_AT_CONFIRMATION_PAGE);
      // TODO: click handlers
      break;
    }
    case BASKET_CONFIRMATION_PAGE: {
      const btnsOrderPage = document.querySelectorAll(BUTTON_REMOVE_AT_ORDER_PAGE);
      for (let i = 0; i < btnsOrderPage.length; i++) {
        const btn = btnsOrderPage[i];
        btn.addEventListener('click', (e) => {
          const dataProduct = btn.getAttribute('data-product').match(/^remove(\d+)$/i);
          if (dataProduct.length === 2) {
            store.dispatch({
              type: 'EVENTS_CART_PRODUCT_REMOVE',
              payload: { productID: dataProduct[1], validPageType: BASKET_CONFIRMATION_PAGE }
            });
          }
        });
      }
      break;
    }
    case DELIVERY_PAGE: {
      const linksDeliveryPage = document.querySelectorAll(LINK_REMOVE_AT_DELIVERY_PAGE);
      for (let i = 0; i < linksDeliveryPage.length; i++) {
        const link = linksDeliveryPage[i];
        link.addEventListener('click', (e) => {
          const regexMatches = link.href.match(/^.+\/order_delivery\/\d+_(\d+)\//i);
          if (regexMatches.length === 2) {
            store.dispatch(
              {
                type: 'EVENTS_CART_PRODUCT_REMOVE',
                payload: {
                  productID: regexMatches[1],
                  validPageType: DELIVERY_PAGE
                }
              }
            );
          }
        });
      }
      break;
    }
    default:
      break;
  }
}

/**
 * Dispatches the UCMS related actions
 *
 * @param      {Store}  store          The store
 * @param      {object} settingsData   data from app.settings
 */
const initUCMS = (store, settingsData) => {
  // we're on a listing page of any type if we have the sSortBy selectbox in the DOM
  const selectSortBy = document.querySelector('#sSortBy');
  const selectViewCount = document.querySelector('#sViewCount');

  const defaultSortBy = settingsData['ucms.default-sort-by'];
  const defaultProductsPerPage = settingsData['ucms.default-products-per-page'];

  // let the default values be the base for current values for the case where there are
  // no selectboxes on the listing page
  let currentSortBy = defaultSortBy;
  let currentProductsPerPage = null;

  if (selectSortBy) {
    currentSortBy = selectSortBy.value.split('/').pop();
  }

  if (selectViewCount) {
    currentProductsPerPage = parseInt(selectViewCount.value, 10);
  }

  if (selectSortBy) {
    store.dispatch({
      type: 'INIT_UCMS_RANK_AND_SHOW',
      payload: {
        currentSortBy, currentProductsPerPage, defaultSortBy, defaultProductsPerPage
      }
    });
  }
};

const dispatchSearchRefinementAction = (store, attribute, value, selected) => {
  store.dispatch({
    type: 'EVENTS_SEARCH_REFINED',
    payload: { attribute, value, selected }
  });
};

/**
 * Attaches event listeners to the elements in the filter section
 * and handles the events
 *
 * @param      {Store}   store         The store
 * @param      {object}  settingsData  The settings data
 */
const initSearchPageEvents = (store, settingsData) => {
  const filterSections = document.querySelectorAll('#search-filters nav.filters-cat');

  for (let s = 0; s < filterSections.length; s++) {
    const section = filterSections[s];
    let sectionTitle = section.querySelector('h3');
    let checkboxes = null;

    if (sectionTitle) {
      sectionTitle = sectionTitle.innerText.trim();

      switch (sectionTitle.toLowerCase()) {
        // price range
        case 'price': {
          // text inputs
          const submitButton = section.querySelector('input[type="submit"]');
          if (submitButton) {
            submitButton.addEventListener('click', (e) => {
              const numberInputs = section.querySelectorAll('input[type="number"]');
              if (numberInputs.length === 2) {
                const priceMin = numberInputs[0].value;
                const priceMax = numberInputs[1].value;
                dispatchSearchRefinementAction(store, sectionTitle,
                  `${priceMin}-${priceMax}`, true);
              }
            });
          }
          // checkboxes
          checkboxes = section.querySelectorAll('input[type="checkbox"]');
          for (let i = 0; i < checkboxes.length; i++) {
            checkboxes[i].addEventListener('click', function onchange(e) {
              dispatchSearchRefinementAction(store,
                sectionTitle,
                this.value
                  .replace(/xx-(\d+)/, 'under $1')
                  .replace(/(\d+)-xx/, 'over $1'),
                this.checked);
            });
          }
          break;
        }
        // links
        case 'product category': {
          const links = section.querySelectorAll('ul > li > a');
          for (let i = 0; i < links.length; i++) {
            links[i].addEventListener('click', function onclick(e) {
              let eventValue = null;
              const titleTokens = this.innerText ? this.innerText.trim().match(/^(.+)\s\(\d+\)$/)
                : [];
              if (titleTokens && titleTokens.length === 2) {
                eventValue = titleTokens[1].trim();
              }
              dispatchSearchRefinementAction(store, sectionTitle, eventValue, true);
            });
          }
          break;
        }
        // checkboxes
        default: {
          checkboxes = section.querySelectorAll('input[type="checkbox"]');
          for (let i = 0; i < checkboxes.length; i++) {
            checkboxes[i].addEventListener('click', function onchange(e) {
              let eventValue = null;
              if (this.id.substr(0, 6) === 'rating') {
                eventValue = this.value;
              } else if (this.value === 'delivery') {
                eventValue = this.id.toUpperCase();
              } else {
                const label = this.parentNode.querySelector('label');
                const labelTitleTokens = label && label.innerText
                  ? label.innerText.trim().match(/^(.+)\s\(\d+\)$/) : [];
                if (labelTitleTokens && labelTitleTokens.length === 2) {
                  eventValue = labelTitleTokens[1].trim();
                }
              }
              dispatchSearchRefinementAction(store, sectionTitle, eventValue, this.checked);
            });
          }
          break;
        }
      }
    }
  }
};

/**
 * Initializes datalayer module with initial digitalData and possible group call data
 * - dispatches action for page object initialization
 * - attaches event listeners for basket add/remove actions
 *
 * @param      {Store}  store   redux store
 * @param      {object}  data   configuration/initialization data
 */
export default function initDataLayer(store, data) {
  const dataElement = document.getElementById('app.digitalData');

  let digitalData = {};
  if (typeof dataElement === 'object' && dataElement !== null) {
    digitalData = dataElement.innerHTML ? JSON.parse(dataElement.innerHTML) : {};
  }
  const groupcallData = window.GROUPCALL_RESULT ? window.GROUPCALL_RESULT.digitalData : {};
  // UISettings is not initialized at this point yet, so we're pulling it right out of the HTML
  const settingsElement = document.getElementById('app.settings');
  let settingsData = {};
  if (typeof settingsElement === 'object' && settingsElement !== null) {
    settingsData = settingsElement.innerHTML ? JSON.parse(settingsElement.innerHTML) : {};
  }

  store.dispatch({
    type: 'INIT_DIGITAL_DATA',
    digitalData: {
      ...digitalData, ...groupcallData
    }
  });
  store.dispatch({ type: 'INIT_PAGE_OBJECT', document: data.document });

  initUCMS(store, settingsData);
  initBasketEvents(store);
  initChatWindowEventHandlers(store);
  initSearchPageEvents(store, settingsData);
}
